const body = document.querySelector('body');
const hamburger = document.querySelectorAll('.c-hamburger');
const overlay = document.querySelector('.c-overlay');
const mobileNav = document.querySelector('.c-mobile-nav');

/**
 * Overlay open animation
 */

const handleOverlayOpen = (hamburger) => {

    hamburger.setAttribute('aria-pressed', true);
    overlay.setAttribute('aria-hidden', false);
    mobileNav.setAttribute('aria-hidden', false);
    body.style.overflow = 'hidden';
    
}

/**
 * Overlay close animation
 */

const handleOverlayClose = (hamburger) => {

    hamburger.setAttribute('aria-pressed', false);
    overlay.setAttribute('aria-hidden', true);
    mobileNav.setAttribute('aria-hidden', true);
    body.style.overflow = 'auto';

}

/**
 * Hamburger click event
 */

const handleHamburgerClick = () => {

    hamburger.forEach(hamburger => {
        hamburger.addEventListener('click', () => {
            hamburger.getAttribute('aria-pressed') === 'true' ? handleOverlayClose(hamburger) : handleOverlayOpen(hamburger);
        });
    
        document.addEventListener('keydown', (e) => {
            if(hamburger.getAttribute('aria-pressed') === 'true' && e.key === 'Escape') {
                handleOverlayClose(hamburger);
            }
        });
    });

}

export { handleHamburgerClick }